export default {
    //ProjectsList
    your_created_projects: "Els teus projectes creats",
    new_project: "Nou Curs",
    search_course_placeholder: "Busca el teu projecte",
    projects_name: "NOM DEL CURS",
    update_at: 'Actualitzat el ',
    coming_soon: 'Properament',
    search_your_project: 'Busca el teu curs...',
    project_name: 'Nom del curs',
    loading_projects: 'Carregant projectes...',

    //ProjectEditComponent
    modify_project: 'Modificant el teu projecte',
    general: 'General',
    layout: 'Plantilla',
    access: 'Accés',
    branding: 'Branding',
    product_page: 'Pàgina de Producte',
    sale: 'Venda',
    seo_text: 'SEO',
    product: 'Producte',

    //CategoriesSlideOverComponent
    categories: 'Categories',
    text_category: 'Classifica els teus productes per categories, així facilitaràs als teus alumnes comprar els teus cursos.',
    select_category: 'Selecciona categoria...',
    ebook: 'E-book',
    online_project: 'Curs en línia',
    blended_learning: 'Curs semipresencial',
    online_program: 'Programa Online',
    webinar_consulting: 'Webinar / Consultoria online',
    remove_category: 'Eliminar categoria',
    href_help: 'Vull saber més sobre les categories',

    //ProjectEdit
        //CustomCategoriesComponent
        //ProjectGeneralComponent
        category: 'Categoria',
        duration: 'Durada',
        featured_product: 'Producte destacat',
        publish_project: 'Publicar Projecte',
        delete_project: 'Esborrar Curs',
        warning_delete: 'Atenció!',
        message_delete_project: 'En eliminar el curs perdràs totes les dades definitivament.',
        question_delete_project: 'Esteu segur que voleu suprimir aquest curs?',
        delete: 'Eliminar',
        confirmation_delete_project: '(*) Aquesta casella és obligatòria per eliminar el curs',
        navigation: 'Navegació',
        navigation_free: 'Lliure',
        navigation_secuential: 'Seqüencial',
        navigation_without_restriction: "Sense restriccions. L'usuari podrà navegar lliurement pel curs (excloent-ne els cursos amb contingut per degoteig)",
        navigation_completed_restriction: "L'alumne ha de completar cada unitat d'aprenentatge abans de continuar la següent. La finalització de les unitats daprenentatge pot establir-se de diferents maneres.",
        quest_lesson_complete: 'Quan serà considerada una lliçó completada?',
        lesson_complete_at_visit: 'En ser visitada',
        lesson_at_visit_info: 'En entrar en una lliçó es completarà automàticament al progrés total del curs. (Per defecte)',
        lesson_complete_at_see: 'En visualitzar el contingut completament',
        lesson_at_see_info: 'Es marcarà com a completat en visualitzar el contingut completament (vídeo, ebook, podcast)',
        lesson_complete_on_time: 'En romandre un temps',
        lesson_on_time_info: 'Es completarà en estar a cada lliçó el temps indicat (HH:mm)',
        automatic_navigation: 'Navegació automàtica',
        automatic_navigation_disabled: 'Desactivat',
        automatic_navigation_enabled: 'Activat',
        automatic_navigation_info: 'Quan completeu el contingut d\'una lliçó passareu a la següent lliçó corresponent.',
        //PageComponent
        principal_page: 'Pàgina principal',
        objects_presentation: 'Presentació i objectes',
        learning_objectives: 'No us oblideu de descriure breument els objectius d\'aprenentatge.',
        teaching_staff: 'Metodologia i professorat',
        public: 'Públic',
        content: 'Contingut',
        sidebar: 'Barra Lateral',
        //ProductBrandingComponent
        banner: 'Banner',
        upload_banner: 'Puja el teu banner',
        banner_format: 'PNG, JPG, GIF fins a 3MBm',
        promotional_video: 'Vídeo Promocional',
        video_url: 'URL del vídeo',
        video_info: 'Si tens un vídeo promocional, col·loca aquí la url del vídeo a Youtube o Vimeo.',
        //SellComponent
        price_management: 'Gestió de preus',
        sell_price: 'Preu de venda',
        tax: 'A €. (-3% taxes)',
        price_offer: "Preu d'oferta",
        text_configuration: 'Configuració de textos',
        free_text_button: 'Títol de botó de compra gratuït',
        text_if_free: 'Aquest títol apareixerà si el teu producte és gratuït',
        on_sale: 'En venda',
        sale_info: 'Si està activat el teu producte estarà a la venda',

        //SeoComponent
        seo_configuration: 'Configuració SEO',
        seo_title: 'Títol SEO',
        slug: 'Slug',
        seo_description: 'Descripció SEO',

    //ProjectListComponent
    featured: 'Destacat',
    classroom: 'Aula',
    slug_text: 'slug',
    project: 'projecte',
    projects: 'projectes',
    preview: 'Previsualitzar',

    //ProjectAccessComponent
    access_project: 'Accés al curs',
    draft: 'Esborrany',
    draft_text: 'Aquest projecte no es mostrarà al catàleg i podrà ser editat',
    published: 'Publicat',
    published_text: 'Aquest projecte està publicat i els usuaris podran accedir-hi',
    private: 'Privat',
    private_text: 'Aquest projecte és privat, els usuaris dʻaquest curs es donaran dʻalta manualment',
    coming_soon_access: 'Properament',
    coming_soon_access_text: 'Aquest projecte es mostrarà al catàleg de cursos però no s\'hi podrà accedir',
    enrollment_closed: 'Matriculació tancada',
    enrollment_closed_text: 'Només els usuaris matriculats podran entrar al curs. El curs apareixerà al catàleg però no es podran matricular nous usuaris',
    course_expiration: 'Caducitat del curs',
    project_expiration_info: 'El teu curs serà accessible en aquest període de temps. En acabar, es denegarà l\'accés al curs als usuaris matriculats.',
    init_date: "Data d'inici",
    project_delete: 'Esborrar',
    init_date_selected: "Data d'inici seleccionada",
    end_date: 'Data de fi',
    date_delete: 'Esborrar',
    end_date_selected: 'Data de finalització seleccionada',

    //ProjectContentComponent
    new_section: 'Nova Secció',
    section_title: 'Títol de la secció: ',
    create_section: 'Crear secció',
    import_section: 'Importar secció',
    lesson_title: 'Títol de la selecció:',
    new_lesson: 'Nova lliçó',

    //AttachProductListComponent
    attached_products: 'Productes Associats',
    attach_product: 'Adjuntar Producte',
    loading_attached_products: 'Carregant productes associats...',
    unattach_product: 'Desassociar producte',
    info_unattach_product: 'En desasociar el producte al projecte, els alumnes que comprin aquest producte no podran accedir al projecte.',
    quest_unattach_product: 'Segur que vols desasociar el producte ',
    no_product_attached: 'NO HI HA PRODUCTES ASSOCIATS',

    //AttachProductSlideOverComponent
    attach_product_slide: 'Associar Producte',
    selected_product: 'Producte seleccionat',
    quest_attach_product: 'Vols adjuntar aquest producte?',

    //ProjectEditContentComponent
    back: 'Tornar',
    select_type_content: 'Seleccioneu el tipus de contingut',
    type_lesson: 'Tipus de lliçó: ',
    html_editor: 'Editor HTML',
    html_info_text: 'Insereix el codi HTML que vulguis mostrar a la teva lliçó',
    insert_video_url: 'Insereix la URL del vídeo',
    content_index: 'Índex de continguts',
    student_list: "Llista d'estudiants",

    //ProjectLayoutContent
    image: 'Imatge',
    classic_design: 'Aspecte Clàssic',

    //Visibilidad staff (FE-001)
    edit_project: 'Editar curs',

    //Listado de proyectos (FE-003)
    empty_projects_title: 'Encara no hi ha cursos',
    empty_projects_text: 'Quan es creï un curs en aquesta acadèmia apareixerà aquí.',
    export_students: 'Exportar alumnes',
    unexpected_error: 'S\'ha produït un error inesperat',

    //Contenedor de edición (FE-005)
    loading_project: 'Carregant el curs...',

    //Secciones del contenido (FE-006)
    course_content: 'Contingut del curs',
    section_title_label: 'Títol de la secció',
    section_title_placeholder: 'P. ex.: Introducció',
    section_title_required: 'El títol de la secció és obligatori',
    section_created: 'Secció creada',
    section_saved: 'Secció desada',

    //Estados vacíos y lecciones (FE-008)
    empty_sections_title: 'Aquest curs encara no té contingut',
    empty_sections_text: 'Crea una secció per començar a organitzar les lliçons.',
    empty_lessons: 'Aquesta secció encara no té lliçons.',
    add_lesson: 'Afegir lliçó',
    lesson_title_label: 'Títol de la lliçó',
    lesson_title_placeholder: 'P. ex.: Benvinguda al curs',
    lesson_title_required: 'El títol de la lliçó és obligatori',
    lesson_created: 'Lliçó creada',
    edit_lesson_content: 'Editar el contingut de la lliçó',

    //Pantalla de lección (FE-009)
    back_to_content: 'Tornar al contingut',
    loading_lesson: 'Carregant la lliçó...',

    //Cabecera de lección con contexto (FE-053)
    lesson_breadcrumb: 'Posició de la lliçó al curs',
    section_n: 'Secció {number}',
    lesson_n_of_total: 'Lliçó {number} de {total}',
    previous_lesson: 'Anterior',
    next_lesson: 'Següent',
    previous_lesson_named: 'Lliçó anterior: {title}',
    next_lesson_named: 'Lliçó següent: {title}',
    course_outline_short: 'Índex',
    course_outline: 'Índex del curs',
    current_lesson: '(lliçó actual)',
    rename_lesson_named: 'Canviar el nom de la lliçó «{title}»',
    view_as_student: 'Veure com a alumne',
    opens_in_new_tab: '(s\'obre en una pestanya nova)',

    lesson_editing_coming_soon: 'L\'edició del contingut de les lliçons estarà disponible properament.',

    //Adjuntar producto (FE-010)
    product_attached: 'Producte associat al curs',
    product_detached: 'Producte desassociat del curs',

    //Pestaña General (FE-011)
    status_label: 'Estat',
    general_editing_coming_soon: 'L\'edició de les dades del curs (títol, estat, esborrat) estarà disponible properament.',

    //Pestaña Acceso (FE-012)
    enrol_configuration: 'Configuració de matriculació',
    enrol_configuration_empty: 'Fes clic al botó per crear una configuració de matriculació. Els alumnes iniciaran i finalitzaran la matrícula al curs segons aquesta configuració.',
    enrol_configuration_create: 'Configurar matriculació',
    enrol_time_start: 'Temps d\'inici',
    enrol_time_end: 'Temps de fi',
    enrol_time_value: 'Quantitat',
    enrol_time_unit: 'Unitat de temps',
    time_unit_hours: 'Hores',
    time_unit_days: 'Dies',
    time_unit_weeks: 'Setmanes',
    time_unit_months: 'Mesos',
    time_unit_years: 'Anys',
    enrol_configuration_invalid_value: 'Els temps han de ser nombres enters iguals o majors que 0',
    enrol_configuration_invalid_unit: 'Selecciona una unitat de temps vàlida',
    enrol_configuration_saved: 'Configuració de matriculació desada',
    enrol_configuration_deleted: 'Configuració de matriculació eliminada',

    //Textos del editor de contenido (FE-013)
    drag_section: 'Arrossega per reordenar la secció',
    drag_lesson: 'Arrossega per reordenar la lliçó',
    delete_section: 'Esborrar secció',
    delete_lesson: 'Esborrar lliçó',
    sections_order_saved: 'Ordre de seccions desat',
    sections_order_error: 'Error en desar l\'ordre de les seccions',
    lessons_order_saved: 'Ordre de lliçons desat',
    lessons_order_error: 'Error en desar l\'ordre de les lliçons',

    // FE-020 · Borrar secciones y lecciones
    delete_section_title: 'Vols esborrar la secció «{title}»?',
    delete_section_message: 'La secció s\'eliminarà del curs.',
    delete_section_with_lessons_message: 'La secció conté {count} lliçó(ns) que també s\'esborraran. Els alumnes deixaran de veure-les.',
    delete_lesson_title: 'Vols esborrar la lliçó «{title}»?',
    delete_lesson_message: 'La lliçó i el seu contingut s\'eliminaran del curs.',
    delete_confirm_button: 'Esborrar',
    section_deleted: 'Secció esborrada',
    lesson_deleted: 'Lliçó esborrada',

    // FE-021 · Renombrar lecciones
    lesson_saved: 'Lliçó desada',

    // FE-022 · Reordenar y mover lecciones
    move_section_up: 'Pujar secció',
    move_section_down: 'Baixar secció',
    move_lesson_up: 'Pujar lliçó',
    move_lesson_down: 'Baixar lliçó',
    empty_lessons_drop: 'Aquesta secció encara no té lliçons. Pots afegir-ne una o arrossegar-la aquí des d\'una altra secció.',

    // FE-023 · Publicar y vista previa gratuita
    status_published: 'Publicada',
    status_draft: 'Esborrany',
    publish_section: 'Publicar secció',
    unpublish_section: 'Despublicar secció',
    publish_lesson: 'Publicar lliçó',
    unpublish_lesson: 'Despublicar lliçó',
    section_published: 'Secció publicada',
    section_unpublished: 'Secció despublicada: els alumnes ja no la veuen',
    lesson_published: 'Lliçó publicada',
    lesson_unpublished: 'Lliçó despublicada: els alumnes ja no la veuen',
    free_preview_badge: 'Vista prèvia',
    free_preview_enabled: 'La lliçó ara és de vista prèvia gratuïta',
    free_preview_disabled: 'La lliçó ja no és de vista prèvia gratuïta',

    //Editor de lección por bloques (FE-030)
    loading_blocks: 'Carregant el contingut de la lliçó...',
    drag_block: 'Arrossega per reordenar el bloc',
    move_block_up: 'Pujar bloc',
    move_block_down: 'Baixar bloc',
    delete_block: 'Treure bloc',
    block_type_not_editable: 'Aquest tipus de bloc encara no es pot editar des d\'aquí.',
    add_block: 'Afegir bloc',
    discard_changes: 'Descartar canvis',
    blocks_load_error: 'No s\'ha pogut carregar el contingut de la lliçó',
    blocks_saved: 'Contingut de la lliçó desat',
    blocks_save_error: 'Error en desar el contingut de la lliçó',
    block_type_rich_text: 'Text',
    block_rich_text_required: 'El bloc de text no pot estar buit',

    //Barra de guardado y estados del editor (FE-051)
    empty_blocks_title: 'Aquesta lliçó encara no té contingut',
    empty_blocks_text: 'Afegeix un bloc de text, una pàgina incrustada o un altre tipus per començar.',
    add_first_block: 'Afegir el primer bloc',
    blocks_status_dirty: 'Canvis sense desar',
    blocks_status_saving: 'Desant...',
    blocks_status_saved_at: 'Desat a les {time}',
    blocks_status_clean: 'Sense canvis',
    blocks_errors_count: '{count} bloc amb errors | {count} bloc amb errors | {count} blocs amb errors',
    blocks_go_to_first_error: 'Anar al primer',
    save_shortcut_title: 'Desar ({shortcut})',
    save_shortcut_hint: '{shortcut} per desar',
    discard_confirm_title: 'Vols descartar els canvis?',
    discard_confirm_text: 'La lliçó tornarà a estar com la darrera vegada que la vas desar.',

    //Guardado en lote del editor de bloques (FE-055)
    blocks_conflict_title: 'Una altra persona ha desat aquesta lliçó',
    blocks_conflict_text: 'Els teus canvis continuen a la pantalla. Si recarregues, veuràs la versió desada i perdràs el que no has desat.',
    blocks_conflict_reload: 'Recarregar la lliçó',
    blocks_conflict_keep: 'Continuar editant',
    blocks_conflict_status: 'Una altra persona ha desat aquesta lliçó. Recarrega per poder desar.',
    blocks_conflict_fallback: 'Una altra persona ha desat aquesta lliçó mentre l’editaves.',

    //Insertar y manejar bloques (FE-052)
    block_actions: 'Accions del bloc',
    block_position: 'Bloc {position} de {total}',
    collapse_block: 'Plegar el bloc',
    expand_block: 'Desplegar el bloc',
    duplicate_block: 'Duplicar',
    move_block_first: 'Moure al principi',
    move_block_last: 'Moure al final',
    insert_block_after: 'Inserir un bloc després del bloc {position}',
    block_type_rich_text_description: 'Paràgrafs, títols, llistes, enllaços i imatges.',
    block_type_embed_description: 'Formularis, documents o presentacions de serveis permesos.',
    block_type_video_description: 'Vídeo de YouTube o Vimeo.',
    block_type_quiz_description: 'Preguntes amb correcció automàtica.',

    //Bloque de página embebida (FE-050)
    block_type_embed: 'Pàgina incrustada',
    block_embed_url_invalid: 'Escriu l\'adreça completa de la pàgina, començant per https://',
    block_embed_height_invalid: 'L\'alçada ha de ser un nombre enter entre 100 i 3000 píxels',
    block_embed_domain_not_allowed: 'El domini {host} no està permès per incrustar pàgines',
    embed_url_label: 'Adreça de la pàgina',
    embed_url_placeholder: 'https://docs.google.com/forms/...',
    embed_url_help: 'Només pàgines https de serveis permesos, com Google Forms, Google Docs, Microsoft Forms o Slidebean.',
    embed_height_label: 'Alçada (píxels)',
    embed_height_help: 'Entre {min} i {max}. Si la deixes buida, s\'utilitza l\'alçada per defecte.',
    embed_preview: 'Previsualitzar',
    embed_preview_title: 'Previsualització de la pàgina incrustada',
    embed_preview_after_save: 'La previsualització apareixerà quan desis la lliçó.',

    //Bloque de imagen (FE-057)
    block_type_image: 'Imatge',
    block_type_image_description: 'Una imatge amb text alternatiu i peu opcional.',
    block_image_required: 'Puja una imatge per a aquest bloc',
    block_image_alt_required: 'Escriu el text alternatiu de la imatge',
    block_image_file_invalid: 'La imatge ja no està disponible: puja’n una altra',
    image_choose: 'Triar imatge',
    image_replace: 'Canviar imatge',
    image_drop_hint: 'o arrossega-la aquí',
    image_file_help: 'JPG, PNG, GIF o WebP. Màxim {max} MB.',
    image_uploading: 'Pujant la imatge... {progress} %',
    image_preview_unavailable: 'No es pot mostrar la vista prèvia de la imatge.',
    image_type_invalid: 'Format no admès: fes servir JPG, PNG, GIF o WebP',
    image_too_large: 'La imatge pesa més de {max} MB',
    image_upload_throttled: 'Has pujat moltes imatges seguides. Espera un minut i torna-ho a provar.',
    image_upload_error: 'No s’ha pogut pujar la imatge. Torna-ho a provar.',
    image_alt_label: 'Text alternatiu (obligatori)',
    image_alt_help: 'Descriu en una frase el que mostra la imatge i per què importa a la lliçó, per exemple «Gràfic de vendes que creix cada trimestre del 2025». No comencis per «Imatge de».',
    image_caption_label: 'Peu d’imatge (opcional)',

    //Bloque de archivos descargables (FE-058)
    block_type_file: 'Fitxers descarregables',
    block_type_file_description: 'Documents o altres fitxers perquè l’alumne els descarregui.',
    block_file_required: 'Puja almenys un fitxer per a aquest bloc',
    block_file_too_many: 'Aquest bloc té massa fitxers: treu-ne algun',
    block_file_invalid: 'Algun fitxer ja no està disponible: treu-lo i torna’l a pujar',
    block_file_name_invalid: 'El nom visible d’un fitxer és massa llarg (màxim 255 caràcters)',
    file_empty: 'Aquest bloc encara no té fitxers.',
    file_list_label: 'Fitxers del bloc ({count})',
    file_drag: 'Arrossega per reordenar el fitxer',
    file_open_new_tab: 's’obre en una pestanya nova',
    file_name_label: 'Nom visible (opcional)',
    file_move_up: 'Puja el fitxer',
    file_move_down: 'Baixa el fitxer',
    file_remove: 'Treu el fitxer',
    file_missing: 'Aquest fitxer ja no està disponible. Treu-lo del bloc.',
    file_unnamed: 'Fitxer sense nom',
    file_uploading: 'Pujant... {progress} %',
    file_queued: 'En espera',
    file_retry: 'Torna a provar la pujada',
    file_dismiss: 'Descarta',
    file_choose: 'Tria fitxers',
    file_add_more: 'Afegeix més fitxers',
    file_drop_hint: 'o arrossega’ls aquí',
    file_limit_reached: 'Has arribat al màxim de {max} fitxers en aquest bloc.',
    file_help: 'PDF, Word, Excel, PowerPoint, OpenDocument, RTF, TXT, CSV, ZIP, imatges (JPG, PNG, GIF, WebP) o MP3. Fins a {max} MB per fitxer i {count} fitxers per bloc.',
    file_type_invalid: 'Format no admès',
    file_too_large: 'El fitxer pesa més de {max} MB',
    file_too_many: 'No hi caben més fitxers: el màxim és {max} per bloc',
    file_upload_throttled: 'Has pujat molts fitxers seguits. Espera un minut i torna-ho a provar.',
    file_upload_error: 'No s’ha pogut pujar el fitxer. Torna-ho a provar.',

    //Bloque de vídeo (FE-031)
    block_type_video: 'Vídeo',
    block_video_required: 'Puja un vídeo o enganxa un enllaç de YouTube o Vimeo',
    video_source_label: 'Origen del vídeo',
    video_source_upload: 'Pujar vídeo',
    video_source_embed: 'Enllaç de YouTube o Vimeo',
    video_uploaded: 'Vídeo pujat',
    video_upload_error: 'Error en pujar el vídeo',
    video_url_label: 'Enllaç del vídeo',
    video_url_placeholder: 'https://www.youtube.com/watch?v=...',
    video_url_help: 'Admet enllaços de YouTube (inclosos Shorts i youtu.be) i de Vimeo.',
    video_preview: 'Previsualitzar',
    video_url_unsupported: 'L\'enllaç no és de YouTube ni de Vimeo o no és vàlid',
    video_url_error: 'No s\'ha pogut comprovar l\'enllaç del vídeo',

    //Editor de quizzes (FE-033)
    block_type_quiz: 'Qüestionari',
    block_quiz_required: 'Crea el qüestionari abans de desar',
    quiz_empty: 'Aquest bloc encara no té cap qüestionari.',
    quiz_create: 'Crear qüestionari',
    quiz_default_title: 'Qüestionari',
    quiz_created: 'Qüestionari creat. Desa la lliçó per mantenir-lo en aquest bloc.',
    quiz_loading: 'Carregant el qüestionari...',
    quiz_load_error: 'No s\'ha pogut carregar el qüestionari',
    retry: 'Reintentar',
    quiz_save_error: 'Error en desar el qüestionari',
    quiz_settings_saved: 'Configuració del qüestionari desada',
    quiz_title_label: 'Títol del qüestionari',
    quiz_pass_percentage_label: 'Nota mínima per aprovar (%)',
    quiz_max_attempts_label: 'Intents màxims',
    quiz_unlimited: 'Il·limitats',
    quiz_max_attempts_help: 'Deixa-ho buit per permetre intents il·limitats.',
    quiz_required_to_progress: 'Cal aprovar per avançar',
    quiz_shuffle: 'Barrejar preguntes i respostes',
    quiz_save_settings: 'Desar configuració',
    quiz_title_required: 'El títol del qüestionari és obligatori',
    quiz_pass_percentage_invalid: 'La nota mínima ha de ser un nombre enter entre 0 i 100',
    quiz_max_attempts_invalid: 'Els intents han de ser un nombre enter més gran que 0',
    quiz_questions_title: 'Preguntes ({count})',
    quiz_no_questions: 'Afegeix almenys una pregunta.',
    quiz_add_question: 'Afegir pregunta',
    quiz_edit_question: 'Editar pregunta',
    quiz_delete_question: 'Esborrar pregunta',
    quiz_delete_question_title: 'Esborrar aquesta pregunta?',
    quiz_delete_question_text: 'La pregunta i les seves respostes s\'esborraran del qüestionari. Aquesta acció no es pot desfer.',
    quiz_question_saved: 'Pregunta desada',
    quiz_question_deleted: 'Pregunta esborrada',
    quiz_drag_question: 'Arrossega per reordenar la pregunta',
    quiz_move_question_up: 'Pujar pregunta',
    quiz_move_question_down: 'Baixar pregunta',
    quiz_order_error: 'Error en desar l\'ordre de les preguntes',
    quiz_remove_block_title: 'Vols treure el bloc de qüestionari?',
    quiz_remove_block_text: 'En desar la lliçó s\'esborrarà el qüestionari amb les seves preguntes i els intents dels alumnes. Fins que desis, pots descartar els canvis per recuperar-lo.',
    quiz_orphan_delete_error: 'La lliçó s\'ha desat, però no s\'ha pogut esborrar el qüestionari d\'un bloc tret. Es tornarà a provar la propera vegada que desis.',
    quiz_statement_label: 'Enunciat',
    quiz_question_type_label: 'Tipus de pregunta',
    quiz_type_single: 'Opció única',
    quiz_type_multiple: 'Opció múltiple',
    quiz_options_label: 'Respostes',
    quiz_options_help_single: 'Marca l\'única resposta correcta.',
    quiz_options_help_multiple: 'Marca totes les respostes correctes.',
    quiz_correct: 'Correcta',
    quiz_option_text_label: 'Resposta {number}',
    quiz_option_feedback_label: 'Feedback en triar-la (opcional)',
    quiz_add_option: 'Afegir resposta',
    quiz_remove_option: 'Treure resposta',
    quiz_explanation_label: 'Explicació (opcional)',
    quiz_explanation_help: 'Es mostra a l\'alumne després de respondre.',
    quiz_question_type_required: 'Tria el tipus de pregunta',
    quiz_statement_required: 'L\'enunciat és obligatori',
    quiz_min_options: 'Afegeix almenys dues respostes',
    quiz_option_text_required: 'Totes les respostes han de tenir text',
    quiz_single_requires_one_correct: 'Marca exactament una resposta correcta',
    quiz_multiple_requires_correct: 'Marca almenys una resposta correcta',

    // FE-040 · Crear curso desde el panel
    new_course: 'Nou curs',
    new_course_title: 'Crear un curs',
    new_course_text: 'Es crearà en esborrany. Després podràs afegir-hi el contingut i completar-ne la fitxa.',
    course_title_label: 'Títol del curs',
    course_title_placeholder: 'Ex.: Introducció a la fotografia',
    course_title_required: 'El títol del curs és obligatori',
    create_course: 'Crear curs',
    course_created: 'Curs creat',

    // FE-041 · Editar la ficha del curso
    archived: 'Arxivat',
    course_details_loading: 'Carregant la fitxa del curs...',
    course_subtitle_label: 'Subtítol',
    course_description_label: 'Descripció',
    course_cover_label: 'Imatge de portada',
    course_cover_alt: 'Portada del curs',
    course_cover_empty: 'Sense portada',
    course_cover_help: 'Imatge en proporció 16:9 (recomanat 1280×720), fins a 5 MB.',
    course_cover_invalid: 'Selecciona una imatge de 5 MB com a màxim',
    course_slug_label: 'URL amigable (slug)',
    course_slug_help: 'Només minúscules, números i guions. Si el deixes buit, es genera a partir del títol.',
    course_slug_invalid: 'L\'slug només pot contenir minúscules, números i guions',
    course_saved: 'Fitxa del curs desada',

    // FE-042 · Duplicar y borrar curso
    duplicate_course: 'Duplicar curs',
    course_duplicated: 'Curs duplicat. La còpia està en esborrany.',
    delete_course: 'Esborrar curs',
    delete_course_help: 'El curs deixarà d\'estar disponible per als alumnes. Aquesta acció no es pot desfer des del panell.',
    delete_course_title: 'Vols esborrar aquest curs?',
    delete_course_text: 'S\'esborraran el curs, les seves seccions i les seves lliçons. Es conserva l\'historial dels alumnes.',
    delete_course_has_students: 'Aquest curs té alumnes matriculats i en perdran l\'accés. Si vols continuar, torna a confirmar.',
    delete_course_confirmation_label: 'Per confirmar, escriu el nom del curs:',
    delete_course_force: 'Esborrar igualment',
    course_deleted: 'Curs esborrat',

    // ProjectContentComponent · rediseño del editor de contenido
    sections_count: 'Sense seccions | 1 secció | {count} seccions',
    lessons_count: 'Sense lliçons | 1 lliçó | {count} lliçons',
    create_lesson: 'Crear lliçó',
    section_number: 'Títol de la secció {number}',
    edit_content: 'Editar',
    edit_lesson_content_of: 'Editar el contingut de «{title}»',

    //Secciones plegables con resumen (FE-061)
    expand_all_sections: 'Desplegar-ho tot',
    collapse_all_sections: 'Plegar-ho tot',
    expand_section: 'Desplegar la secció «{title}»',
    collapse_section: 'Plegar la secció «{title}»',
    section_actions: 'Accions de la secció «{title}»',
    lessons_published_count: 'cap publicada | 1 publicada | {count} publicades',

    //Programación (drip) dentro de la sección (FE-062)
    drip_menu: 'Programació',
    drip_title: 'Programació de la secció',
    drip_help: 'Decideix quan poden veure aquesta secció els alumnes.',
    drip_immediate: 'Disponible des de la matrícula',
    drip_days_option: 'Uns dies després de la matrícula',
    drip_days_label: 'Dies després de la matrícula',
    drip_days_suffix: 'dies després de la matrícula',
    drip_date_option: 'En una data fixa',
    drip_date_label: 'Data a partir de la qual està disponible',
    drip_days_invalid: 'Escriu un nombre enter de dies entre {min} i {max}',
    drip_date_invalid: 'Tria una data vàlida',
    drip_saved: 'Programació de la secció desada',
    drip_badge_days: '{count} dies després de la matrícula | 1 dia després de la matrícula | {count} dies després de la matrícula',
    drip_badge_date: 'Des del {date}',
    drip_edit_of: 'Editar la programació de «{title}»: {schedule}',

    //Filas de lección simplificadas (FE-063)
    lesson_title_edit_hint: 'Fes clic per canviar el nom. Enter desa i Escape desfà.',
    saved_inline: 'Desat',
    free_preview_enable: 'Activar la previsualització gratuïta',
    free_preview_enable_help: 'Qualsevol visitant podrà veure aquesta lliçó sense comprar el curs.',
    free_preview_disable: 'Treure la previsualització gratuïta',
    lesson_actions: 'Accions de la lliçó «{title}»',

    //Duplicar y acciones en lote (FE-065)
    duplicate_lesson: 'Duplicar',
    duplicate_lesson_help: 'La còpia es crea just a sota, en esborrany.',
    duplicate_section: 'Duplicar secció',
    duplicate_section_help: 'Copia la secció amb les seves lliçons just a sota, en esborrany.',
    lesson_duplicated: 'Lliçó duplicada',
    section_duplicated: 'Secció duplicada',
    publish_section_with_lessons: 'Publicar secció i lliçons',
    unpublish_section_with_lessons: 'Despublicar secció i lliçons',
    publish_section_with_lessons_title: 'Vols publicar «{title}» amb les seves lliçons?',
    unpublish_section_with_lessons_title: 'Vols despublicar «{title}» amb les seves lliçons?',
    publish_section_with_lessons_message: 'Es publicarà la secció. Totes les seves lliçons ja estan publicades. | Es publicaran la secció i {count} lliçó en esborrany. Els alumnes les podran veure. | Es publicaran la secció i {count} lliçons en esborrany. Els alumnes les podran veure.',
    unpublish_section_with_lessons_message: 'Es despublicarà la secció. Cap de les seves lliçons està publicada. | Es despublicaran la secció i {count} lliçó publicada. Els alumnes deixaran de veure-les. | Es despublicaran la secció i {count} lliçons publicades. Els alumnes deixaran de veure-les.',
    section_with_lessons_published: 'Secció i lliçons publicades',
    section_with_lessons_unpublished: 'Secció i lliçons despublicades',
    bulk_publish_partial_error: 'No s’ha pogut canviar cap element | No s’ha pogut canviar {count} element: revisa’n l’estat i torna-ho a provar. | No s’han pogut canviar {count} elements: revisa’n l’estat i torna-ho a provar.',

    //Currículo en móvil (FE-064)
    rename_section: 'Canviar el nom de la secció «{title}»',
    rename_lesson: 'Canviar el nom de la lliçó «{title}»',
}
